export const LAYOUT = {
  DRAWER_WIDTH: 200,
  COLLAPSED_DRAWER_WIDTH: 56,
  TOOLBAR_HEIGHT: 64,
  SPACING: {
    xs: 0.5,
    sm: 1.5,
    md: 2,
  },
} as const;
